import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=4ff8e573"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=4ff8e573&prod&lang=scss"
import style1 from "./Datatable.vue?vue&type=style&index=1&id=4ff8e573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports